import { ServiceTypeEnum } from '@generated/graphql';

export const getServiceTypeLabel = (serviceType: ServiceTypeEnum) => {
  return serviceType === ServiceTypeEnum.PERSISTENT_SERVICE
    ? 'Persistent'
    : serviceType === ServiceTypeEnum.MARKETPLACE
      ? 'Marketplace'
      : 'Service';
};
